import {modules, services} from "../../engines/gameEngine";
import {$RealCode} from "./codeHead";

const {ccclass, property} = cc._decorator;

@ccclass
export default class realNameATT extends cc.Component {

    @property(cc.EditBox)
    editCode: cc.EditBox = null;
    @property(cc.EditBox)
    editName: cc.EditBox = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}
    readonly JSON_KEY = 'real-name-code';
    //
    m_commitSuccess: () => void = null;

    async onRealName() {
        //web或已认证
        if (!cc.sys.isNative || this.isRealNameEd()) {
            this.node.active = false;
            return Promise.resolve();
        } else {
            return new Promise<void>(resolve => {
                this.node.active = true;
                this.m_commitSuccess = () => {
                    resolve();
                }
            });
        }
    }

    start() {
    }

    isRealNameEd() {
        let data = services().localStorageSrv.getStorage(this.JSON_KEY, false);
        return Boolean(data);
    }

    protected signed(ID: string): boolean {
        //前6位城市
        // let sixStr = ID.substring(0, 6);
        // if (null == $RealCode.PRE_SIX[sixStr]) {
        //     console.warn('不存在的城市码', sixStr);
        //     return false;
        // }
        //最后一位校验码
        let ans = 0;
        let arr = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        let map: string = "10X98765432";
        for (let i = 0; i < 17; i++) {
            ans += Number(ID[i]) * arr[i];
        }
        if (map[ans % 11] != ID[17]) {
            return false;
        }
        return true;
    }

    onBtnCommit() {
        let name = this.editName.string;
        let code = this.editCode.string;
        if (!(/^(?:[\u4e00-\u9fa5·]{2,16})$/).test(name)) {
            modules().uiControlModule.showMessageBox('请输入正确的姓名');
            return;
        }
        if (code.length < 18) {
            modules().uiControlModule.showMessageBox('请输入正确的身份证号码');
            return;
        }
        let resFunc: () => void;
        if (!(/^[1-9]\d{5}(?:18|19|20)\d{2}(?:0\d|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/).test(code) || !this.signed(code)) {
            resFunc = () => {
                modules().uiControlModule.hideLoading();
                //
                modules().uiControlModule.showMessageBox('实名认证失败，请检查你的输入');
            };
        } else {
            resFunc = () => {
                modules().uiControlModule.hideLoading();
                //成功
                services().localStorageSrv.setStorage(this.JSON_KEY, JSON.stringify({code, name}), false);
                this.node.active = false;
                modules().uiControlModule.showMessageBox('实名认证成功.');
                setTimeout(() => {
                    this.m_commitSuccess();
                }, 1500);
            }
        }
        modules().uiControlModule.showLoading(null, '正在认证…').then(() => {
            this.scheduleOnce(() => {
                resFunc();
            }, 0.3 + Math.random() * 1);
        });
    }


    // update (dt) {}
}
